/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class ModelCreatorController implements angular.IController {
        public files: ModelCreatorPagedResult;
        public erroLoadingData: boolean;
        public supportedDrawingTypes: string[];
        public searchKeywords: string[];
        private associations: OrganizationalUnitViewModel[];
        $onInit = () => { };

        constructor(private $scope: any,
            private ModelCreatorService: ModelCreatorService,
            private universalStorageService: UniversalStorageService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $mdDialog: any,
            private textService: TextService,
            private fileService: FileService,
            private $rootScope: any,
            private organizationService: OrganizationService,
            private organizationSettingsService: OrganizationSettingsService,
            private file: FileModel
        ) {
            this.files = new ModelCreatorPagedResult();
            this.searchKeywords = [];
            this.supportedDrawingTypes = ["Floorplan"] //For now only 'Floorplan' is supported, but more will be supported later...
            var vm = this;

            vm.loadData();

            $scope.imageError = function (sender) {
                if (sender.src != null && sender.src != '' &&
                    vm.fileType(sender.src.match(/(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}$).+|(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}[\?])[^\?]*/g).toString()) == "image" &&
                    sender.src.indexOf('image/resize') == -1) {
                    sender.src = vm.universalStorageService.getThumbnailUrl(sender.src.replace('-w100.', '.'));
                }
                else {
                    sender.src = "/assets/img/no-image-icon-32.png?x=1";
                }
            }

            function onScroll() { // TO-DO: Make this work correctly...
                if (true /* $('#wrapper').scrollTop() + window.innerHeight > $('#main').height() - 280 */) {
                    if (vm.files.scrollId != null) {
                        vm.loadData();
                    }
                }
                vm.windowScroll();
            }

            $scope.$on('$destroy', function () {
                window.removeEventListener('scroll', onScroll, true);
            });
            window.removeEventListener('scroll', onScroll, true);
            window.addEventListener('scroll', onScroll, true);
            vm.loadOrganizations();
        }

        private windowScroll() { // TO-DO: Make this work correctly...
            var element = document.getElementById('bulkActions');
            if (element == null) {
                return;
            }
            var resultContainer = document.getElementById('resultContainer');
            var box = resultContainer.getBoundingClientRect();
            var body = document.body;
            var scrollTop = window.pageYOffset || element.scrollTop || body.scrollTop;
            var clientTop = element.clientTop || body.clientTop || 0;
            var top = box.top + scrollTop - clientTop;
            if (top == 0) {
                return;
            }

            if (top < 120) {
                element.style.position = 'fixed';
                element.style.top = '4px';
                element.style.width = $('#md-dialog-content-area').css('width');
            }
            else {
                element.style.position = 'relative';
            }
        }

        public sendToCreate() {
            var vm = this;
            var projectModel = new ModelCreatorProjectModel();
            projectModel.fileId = vm.file.id;
            projectModel.localizer = vm.file.localizer;
            var selectedFiles = vm.getSelectedFiles();
            selectedFiles.forEach(f => {
                var drawing = new ModelCreatorDrawingModel();
                drawing.drawingType = f.drawingType;
                drawing.floorLevel = f.floorLevel;
                drawing.drawingUrl = f.url;
                drawing.tags = f.tags;
                projectModel.drawings.push(drawing);
            });
            vm.ModelCreatorService.sendToCreate(projectModel).then((data: any) => {
                // TO-DO: Handle "Success..."
                vm.$mdDialog.hide();
            }, (rejection) => {
                // TO-DO: Handle "Failure..."
                this.$mdDialog.show(
                    this.$mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title("Failed")
                        .textContent("Failed to create project in eseeCreate! ReasonCode: " + rejection.status)
                        .ok('OK')
                        .multiple('true')
                );
            });
        }

        public loadData() {
            if (this.files.isLastPage || this.files.isLoading) {
                return;
            }
            this.files.isLoading = true;
            var vm = this;
            this.erroLoadingData = false;
            if (this.files.scrollId != null) {
                this.universalStorageService.scroll(this.files.scrollId).then((data: UniversalStoragePagedResult) => {
                    vm.files.isLoading = false;
                    vm.files.totalNumberOfPages = data.totalNumberOfPages;
                    vm.files.totalNumberOfRecords = data.totalNumberOfRecords;
                    if (data.results != null && data.results.length > 0) {
                        var results = data.results as ModelCreatorViewModel[];
                        results.forEach(r => r.drawingType = "Floorplan"); // Default to drawingType 'Floorplan'
                        vm.files.results = vm.files.results.concat(results);
                        if (data.results.length < 10) {
                            vm.files.isLastPage = true;
                        }
                    }
                    else {
                        vm.files.isLastPage = true;
                    }
                }, () => {
                    vm.erroLoadingData = true;
                    vm.files.isLoading = false;
                    vm.files.isLastPage = true;
                    vm.files.scrollId = null;
                    vm.files.results = [];
                });
            }
            else {
                var filter = new ResultFilterModel();
                filter.associationIds = [this.file.parentOrganizationalUnitId];
                filter.departmentIds = [this.file.organizationalUnitId];
                filter.localizers = [this.file.localizer];
                if (this.searchKeywords.length > 0) {
                    filter.keywords = this.searchKeywords;
                }
                this.universalStorageService.getFiles(filter).then((data: UniversalStoragePagedResult) => {
                    vm.files.isLoading = false;
                    vm.files.totalNumberOfPages = data.totalNumberOfPages;
                    vm.files.totalNumberOfRecords = data.totalNumberOfRecords;
                    var results = data.results as ModelCreatorViewModel[];
                    results.forEach(r => r.drawingType = "Floorplan"); // Default to drawingType 'Floorplan'
                    vm.files.results = vm.files.results.concat(results);
                    vm.files.scrollId = data.scrollId;
                    if (data.results.length < 10) {
                        vm.files.isLastPage = true;
                    }
                }, () => {
                    vm.erroLoadingData = true;
                    vm.files.isLoading = false;
                    vm.files.isLastPage = true;
                    vm.files.scrollId = null;
                    vm.files.results = [];
                });
            }
        }

        public dateToString(date: Date) {
            if (date == null) {
                return null;
            }
            var pad = "00";
            return '' + pad.substring(0, pad.length - date.getDate().toString().length) + date.getDate()
                + '-' + pad.substring(0, pad.length - (date.getMonth() + 1).toString().length) + (date.getMonth() + 1).toString()
                + '-' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
        }

        public showDialog(model: UniversalStorageViewModel, $event) {
            $event.stopPropagation();
            var vm = this;
            var dialog = {
                controller: function () {
                    this.model = model;
                    this.$mdDialog = vm.$mdDialog;
                    this.zoomFactor = 1;
                    var self = this;
                    this.zoomIn = function() {
                        if (this.zoomFactor < 2) {
                            this.zoomFactor += 0.25;
                        }
                    }

                    this.zoomOut = function() {
                        if (this.zoomFactor > 0.5) {
                            this.zoomFactor -= 0.25;
                        }
                    }

                    this.encodeUrl = function (url: string) {
                        return encodeURI(url);
                    }

                    this.imageError = function (sender: any) {
                        sender.src = this.model.url.replace(/-md/g, '').replace(/-sm/g, '');
                        sender.srcset = '';
                    }
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/image-preview.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event,
                multiple: true
            };
            this.$mdDialog.show(dialog);
        }

        public onSearchChanged() {
            this.files.isLastPage = false;
            this.files.scrollId = null;
            this.files.results = [];
            this.loadData();
        }

        public getFileExtension(fileName: string) {
            return fileName.lastIndexOf(".") != -1 ? fileName.split('.').pop().toLowerCase() : '';
        }

        public fileType(fileName: string) {
            if (fileName == null || fileName == "") {
                return "link";
            }
            var extension = this.getFileExtension(fileName);
            switch (extension) {
                // Bmp file extensions
                case "bmp":
                // Jpeg file extensions
                case "jpeg":
                case "jpg":
                case "jpe":
                case "jfif":
                case "jif":
                case "jfi":
                // Png file extensions
                case "png":
                case "apng":
                // Gif file extensions
                case "gif":
                // Svg file extensions
                case "svg":
                    return "image";
            }
            return extension;
        }

        public getThumbnailUrl(image: DrawingViewModel) {
            if (image == null || image.url == null || image.url == '' || this.fileType(image.fileName) != 'image') {
                return null;
            }
            var newFileName = image.url.replace(/(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}$).+|(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}[\?])[^\?]*/g, (match, $1) => {
                var x = match.replace('.', '-w100.');
                return x;
            });
            return newFileName;
        }

        public getPreviewUrl(image: DrawingViewModel) {
            if (image.fileName == null || image.fileName == "") {
                return "/assets/img/baseline-link-24px.svg";
            }
            var extension = this.getFileExtension(image.fileName);
            switch (extension) {
                case "tif":
                    return "/assets/img/tiff.svg";
                case "pdf":
                    return "/assets/img/pdf-icon.png";
                case "dwf":
                    return "/assets/img/dwf-icon.png";
                case "zip":
                    return "/assets/img/zip-icon.png";
            }
            return "/assets/img/file-icon.png";
        }

        public showSpinner() {
            var vm = this;
            var dialog = {
                templateUrl: '/app/dialog/spinner.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false
            };
            this.$mdDialog.show(dialog);
            return dialog;
        }

        public getFileLocality(file: UniversalStorageViewModel) {
            var result = '';
            if (file == null) {
                return ' ';
            }

            if (file.associationId != null && file.associationId != '' && file.associationId != 'null') {
              var association = this.associations.filter(c => c.id == file.associationId);
              if (association != null && association.length > 0) {
                  result += association[0].number;

                  if (file.departmentId != null && file.departmentId != '' && file.departmentId != 'null') {
                    var department = association[0].children.filter(c => c.id == file.departmentId)
                    if (department != null && department.length > 0) {
                        if (result != '') {
                          result += ' - ';
                        }
                        result += department[0].number;
                    }
                  }
              }
            }

            if (file.localizer != null && file.localizer != '' && file.localizer != 'null') {
                if (result != '') {
                    result += ' - ';
                }
                result += file.localizer;
            }
            if (result == '') {
                result = ' ';
            }
            return result;
        }

        private loadOrganizations() {
            var vm = this;
            vm.organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                vm.associations = response;
            });
        }

        public hideStandardLocality(): boolean {
            if (this.organizationSettingsService.uiStyling != null) {
                return this.organizationSettingsService.uiStyling.universalStorageHideStandardLocality();
            }
            return false;
        }

        public showDetailedLocality(): boolean {
            if (this.organizationSettingsService.uiStyling != null) {
                return this.organizationSettingsService.uiStyling.universalStorageShowDetailedLocality();
            }
            return false;
        }

        public getFileAssociationName(file: UniversalStorageViewModel) {
            var vm = this;
            if (file == null) {
                return ' ';
            }
            if (file.associationId != null && file.associationId != '' && file.associationId != 'null') {
                var associationName;
                var association = this.associations.filter(c => c.id == file.associationId);
                if (association != null && association.length > 0) {
                    associationName = association[0].name;
                }
                if (associationName != null && associationName != '') {
                    return associationName;
                }
            }
            return ' ';
        }

        public getFileDepartmentName(file: UniversalStorageViewModel) {
            var vm = this;
            if (file == null) {
                return ' ';
            }
            if (file.associationId != null && file.associationId != '' && file.associationId != 'null') {
                if (file.departmentId != null && file.departmentId != '' && file.departmentId != 'null') {
                    var departmentName;
                    var association = this.associations.filter(c => c.id == file.associationId);
                    if (association != null && association.length > 0) {
                        var department = association[0].children.filter(c => c.id == file.departmentId);
                        if (department != null && department.length > 0) {
                            departmentName = department[0].name;
                        }
                    }
                    if (departmentName != null && departmentName != '') {
                        return departmentName;
                    }
                }
            }
            return ' ';
        }

        public getFilePrimaryLocalizer(file: UniversalStorageViewModel) {
            if (file == null) {
                return ' ';
            }
            if (file.localizers != null && file.localizers.length > 0 && file.localizers[0] != '' && file.localizers[0] != 'null') {
                return file.localizers[0];
            }
            return ' ';
        }

        public getFileAdditionalLocalizers(file: UniversalStorageViewModel) {
            var result = [];
            if (file == null) {
                return ' ';
            }
            if (file.localizers != null && file.localizers.length > 1) {
                for (var i = 1; i < file.localizers.length; i++) {
                    if (file.localizers[i] != '' && file.localizers[i] != 'null') {
                        result.push(file.localizers[i]);
                    }
                }
                return result.length > 0 ? result : ' ';
            }
            return ' ';
        }

        public toggleSelection(file: UniversalStorageViewModel) {
            if (file != null) {
                if (file.active == null) {
                    file.active = false;
                }
                file.active = !file.active;
                var vm = this;
                this.$timeout(() => {
                    vm.windowScroll();
                });
            }
        }

        public getSelectedFiles() {
            if (this.files != null && this.files.results != null) {
                return this.files.results.filter(f => f.active);
            }
            else {
                return [];
            }
        }

        public selectedCount() {
            return this.getSelectedFiles().length;
        }

        public anyFileSelected() {
            return this.selectedCount() > 0;
        }

        public clearSelection() {
            if (this.files != null && this.files.results != null) {
                for (var f of this.files.results) {
                    f.active = false;
                }
            }
        }

        public isLocalUrl(file: UniversalStorageViewModel) {
            if (file != null && file.url != null) {
                return file.url.indexOf('universalstorage') > -1;
            }
            return false;
        }

        public formatDate(timestamp: string, withTime: boolean) {
            if (timestamp == null) {
                return null;
            }
            var dateTimeParts = timestamp.split(' ');
            if (dateTimeParts.length == 2) {
                var dateParts = dateTimeParts[0].split('-');
                if (dateParts.length == 3) {
                    var today = new Date();
                    if (parseInt(dateParts[0]) == today.getDate() && (parseInt(dateParts[1]) == today.getMonth() + 1) && parseInt(dateParts[2]) == today.getFullYear()) {
                        return this.textService.translate('Today') + (withTime ? ' ' + dateTimeParts[1] : '');
                    }
                    else if ((parseInt(dateParts[0]) == today.getDate() - 1) && parseInt(dateParts[1]) == today.getMonth() + 1 && parseInt(dateParts[2]) == today.getFullYear()) {
                        return this.textService.translate('Yesterday') + (withTime ? ' ' + dateTimeParts[1] : '');
                    }
                }
                return dateTimeParts[0] + (withTime ? ' ' + dateTimeParts[1] : '');
            }
            return timestamp;
        }
   }

    ModelCreatorController.$inject = ['$scope', 'ModelCreatorService', 'UniversalStorageService', '$q', '$timeout', '$mdDialog', 'TextService', 'FileService', '$rootScope', 'OrganizationService', 'OrganizationSettingsService', 'file'];

    angular
        .module('eseebase')
        .controller('ModelCreatorController', ModelCreatorController);
}